<template>
  <div
    class="layout-study laytsttd"
    :class="[
      layout,
      spacing,
      mainWidth,
      { 'laytsttd_hspots-hidden': hspotsHidden },
      { 'laytsttd_aside-hidden': asideHidden },
    ]"
  >
    <div class="laytsttd_content">
      <div class="laytsttd_hspots">
        <slot
          name="hspots"
          :onBottom="layout.includes('_rvr')"
        ></slot>
      </div>
      <div class="laytsttd_main">
        <slot name="main"></slot>
      </div>
      <div class="laytsttd_aside">
        <slot name="aside"></slot>
      </div>
    </div>
    <slot name="after"></slot>
  </div>
</template>

<script>
import float_mix from '@/mixins/float_mix'

export default {
  name: 'LayoutStudy',
  mixins: [float_mix],
  props: {
    layout: { default: '' },
    spacing: { default: '' },
    mainWidth: { default: '' },
    hspotsHidden: Boolean,
    asideHidden: Boolean,
  },
}
</script>
<style lang="scss">
.swv_layout_horizontal {
  --hspots-grid-column: 1 / 3;
  --hspots-grid-row: 1;
  --main-grid-column: 1;
  --main-grid-row: 2 / 3;
  --aside-grid-column: 2;
  --aside-grid-row: 2 / 3;
  .laytsttd_content {
    grid-template-columns: var(--laytsttd-main-width) auto;
    grid-template-rows: auto 1fr;
  }
}
.swv_layout_split {
  --hspots-grid-column: 1 / 2;
  --hspots-grid-row: 1;
  --main-grid-column: 1;
  --main-grid-row: 2;
  --aside-grid-column: 2;
  --aside-grid-row: 1 / 3;
  .laytsttd_content {
    grid-template-columns: var(--laytsttd-main-width) auto;
    grid-template-rows: auto 1fr;
  }
}
.swv_layout_horizontal_rvr {
  --hspots-grid-column: 1 / 3;
  --hspots-grid-row: 3;
  --main-grid-column: 1;
  --main-grid-row: 1 / 3;
  --aside-grid-column: 2;
  --aside-grid-row: 1 / 3;
  .laytsttd_content {
    grid-template-columns: var(--laytsttd-main-width) auto;
    grid-template-rows: auto 1fr;
  }
}
.swv_layout_split_rvr {
  --hspots-grid-column: 1 / 2;
  --hspots-grid-row: 3;
  --main-grid-column: 1;
  --main-grid-row: 1 / 3;
  --aside-grid-column: 2;
  --aside-grid-row: 1 / 4;
  .laytsttd_content {
    grid-template-columns: var(--laytsttd-main-width) auto;
    grid-template-rows: auto 1fr;
  }
}

.swv_layout_spacing_large {
  --unit: 1rem;
  --laytsttd-gap: var(--unit);
  --laytsttd-padding: var(--unit);
  --laytsttd-padding-content: 0.75rem;
}
.swv_layout_spacing_medium {
  --unit: 0.625rem;
  --laytsttd-gap: var(--unit);
  --laytsttd-padding: var(--unit);
  --laytsttd-padding-content: 0.3125rem;
}
.swv_layout_spacing_compact {
  --unit: 0.25rem;
  --laytsttd-gap: var(--unit);
  --laytsttd-padding: var(--unit);
  --laytsttd-padding-content: 0.25rem;
}

.small_screen_layout {
  --hspots-grid-column: 1 / 3;
  --hspots-grid-row: 1;
  --main-grid-column: 1;
  --main-grid-row: 2 / 3;
  --aside-grid-column: 2;
  --aside-grid-row: 2 / 3;
  .laytsttd_content {
    grid-template-columns: var(--laytsttd-main-width) auto;
    grid-template-rows: auto 1fr;
  }

  //spacing
  --unit: 0.25rem;
  --laytsttd-gap: var(--unit);
  --laytsttd-padding: var(--unit);
  --laytsttd-padding-content: 0.25rem 0 0.25rem 0;
}

.laytsttd_aside-hidden {
  --hspots-grid-column: 1 / 3;
  --main-grid-column: 1 / 3;
  --main-grid-row: 2 / 3;
  &.swv_layout_horizontal_rvr,
  &.swv_layout_split_rvr {
    --hspots-grid-column: 1 / 3;
    --main-grid-column: 1 / 3;
    --main-grid-row: 1 / 3;
  }
  .laytsttd_aside {
    display: none;
  }
}

.laytsttd_hspots-hidden {
  --main-grid-row: 1 / 2;
  --aside-grid-row: 1 / 2;
  .laytsttd_content {
    grid-template-rows: 1fr;
  }
  .laytsttd_hspots {
    display: none;
  }
}

.reports_layout {
  --laytsttd-main-width: 64%;
}
.strategy_layout {
  --laytsttd-main-width: 58%;
}

.laytsttd {
  flex: 1;
  display: flex;
  min-height: 0;
  min-width: 0;
  & &_content {
    flex: 1;
    display: grid;
    gap: var(--laytsttd-gap);
    padding: var(--laytsttd-padding);
    min-height: 0;
    min-width: 0;
  }
  &_hspots {
    grid-column: var(--hspots-grid-column);
    grid-row: var(--hspots-grid-row);
    display: flex;
    min-height: 0;
    min-width: 0;
  }
  &_main {
    grid-column: var(--main-grid-column);
    grid-row: var(--main-grid-row);
    display: flex;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
  }
  &_aside {
    grid-column: var(--aside-grid-column);
    grid-row: var(--aside-grid-row);
    display: flex;
    min-height: 0;
    min-width: 0;
  }
  &_iconified {
    .laytsttd_hspots {
      height: 0.325rem;
    }
    .laytsttd_hspots,
    .laytsttd_main,
    .laytsttd_aside {
      box-shadow: 0px 0px 1px var(--clr-white-0);
    }
  }
}

@media screen and (orientation: portrait) {
  .small_screen_layout {
    --hspots-grid-column: 1;
    --main-grid-column: 1;
    --aside-grid-column: 1;
    --hspots-grid-row: 1;
    --main-grid-row: 2 / 3;
    --aside-grid-row: 3 / 4;
    .laytsttd_content {
      grid-template-columns: 1fr;
      grid-template-rows: auto 1fr auto;
    }
  }

  .small_screen_layout.laytsttd_main-hidden {
    --hspots-grid-column: 1;
    --aside-grid-column: 1;
    --hspots-grid-row: 1;
    --aside-grid-row: 2 / 4;
    .laytsttd_content {
      grid-template-columns: 1fr;
      grid-template-rows: auto 1fr auto;
    }
    .laytsttd_main {
      display: none;
    }
  }

  .small_screen_layout.laytsttd_aside-hidden {
    --hspots-grid-column: 1;
    --main-grid-column: 1;
    --hspots-grid-row: 1;
    --main-grid-row: 2 / 4;
    .laytsttd_content {
      grid-template-columns: 1fr;
      grid-template-rows: auto 1fr auto;
    }
    .laytsttd_aside {
      display: none;
    }
  }

  // .small_screen_layout.laytsttd_hspots-hidden {
  //   --main-grid-column: 1;
  //   --aside-grid-column: 1;
  //   --main-grid-row: 1 / 3;
  //   --aside-grid-row: 3 / 4;
  //   .laytsttd_content {
  //     grid-template-columns: 1fr;
  //     grid-template-rows: auto 1fr auto;
  //   }
  //   .laytsttd_hspots {
  //     display: none;
  //   }
  // }
}

@media (orientation: portrait) {
  .laytsttd {
    --small-layout-aside-max-height: 33vh;
  }
}
@media screen and (max-width: 1023px) and (orientation: portrait) {
  .laytsttd_range {
    --small-layout-aside-max-height: calc(var(--vh-100) - calc(50vw + 15rem));
  }
}
@media screen and (orientation: landscape) {
  .laytsttd {
    --small-layout-aside-max-height: auto;
  }
}
</style>
